import Vue from 'vue';

Vue.directive('select-on-click', {
  inserted($element) {
    $element.addEventListener('click', () => {
      $element.setSelectionRange(0, $element.value.length);
    });
  },
});
